module.exports = __webpack_public_path__ + "static/img/slider-3.9c6eb7d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/images/slider-3.jpeg
// module id = EllY
// module chunks = 1